/**
 * Task: 152985 Export Filename Fix
 * BY: Anshu Sharma
 * Purpose: Utility functions for extracting filename from Content-Disposition header and downloading blobs with proper filenames
 */

/**
 * Extract filename from Content-Disposition header
 * @param {string} contentDisposition - The Content-Disposition header value
 * @returns {string|null} - The extracted filename or null
 */
export const getFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null;

  // Try to match filename*= (RFC 5987) first, then filename=
  const filenameStarMatch = contentDisposition.match(
    /filename\*=(?:UTF-8'')?([^;\n]*)/i
  );
  if (filenameStarMatch && filenameStarMatch[1]) {
    return decodeURIComponent(filenameStarMatch[1]);
  }

  const filenameMatch = contentDisposition.match(
    /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  );
  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1].replace(/['"]/g, "");
  }

  return null;
};

/**
 * Download a blob with a specific filename
 * @param {string} blobUrl - The blob URL
 * @param {string} filename - The filename to use for download
 */
export const downloadBlobWithFilename = (blobUrl, filename) => {
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  /**
   * Task: 152985 Export Filename Fix
   * BY: Anshu Sharma
   * Purpose: Defer revokeObjectURL to allow Firefox to asynchronously queue and
   *          fetch the blob before the URL is invalidated. Synchronous revocation
   *          causes silent download failures in Firefox (Chrome/Safari are forgiving).
   */
  setTimeout(() => {
    window.URL.revokeObjectURL(blobUrl);
  }, 100);
};
